import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { Button } from '@ui';

import { LINKS } from '../../utils/routes';

export const NavigateToActivitiesButton = () => {
    const navigate = useNavigate();
    const navigateToActivities = useCallback(() => {
        navigate(LINKS.getActivities());
    }, [navigate]);

    return <Button onClick={navigateToActivities}>Return to your Activities</Button>;
};
